import React from 'react';
import { motion } from 'framer-motion';
export function Story() {
  return <section className="py-24 md:py-32 bg-ink-light relative" id="historia" data-id="element-170">
      <div className="container mx-auto px-6" data-id="element-171">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-172">
          <motion.div className="relative h-[600px] lg:h-[800px] w-full" initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/aryiDAzXxfjh2z5bUiYnoD/ChatGPT_Image_18_may_2026,_10_16_38.png" alt="Freddy caminando en la ciudad de noche" className="w-full h-full object-contain object-center grayscale-[20%] contrast-125" data-id="element-174" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent lg:hidden" data-id="element-175"></div>
          </motion.div>

          <motion.div className="max-w-xl" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-176">
            <h2 className="text-4xl md:text-5xl font-serif text-ivory-bright mb-8 leading-tight" data-id="element-177">
              ¿Sientes que estás en el <br data-id="element-178" />
              <span className="font-script text-5xl md:text-6xl text-gold font-normal" data-id="element-179">
                Punto Cero
              </span>{' '}
              de tu vida?
            </h2>

            <div className="space-y-6 text-muted font-light leading-relaxed" data-id="element-180">
              <p className="text-ivory text-lg" data-id="element-181">Soy Freddy Pimentel.</p>
              <p data-id="element-182">Y sé lo que es sentirse perdido emocionalmente.</p>
              <p data-id="element-183">
                A los 13 años cargaba ladrillos para ayudar a sostener a mi
                familia. Años después construí negocios, estabilidad y una vida
                diferente… hasta que tuve que dejarlo todo atrás.
              </p>
              <p data-id="element-184">
                Y cuando llegué a Argentina, volví a empezar desde cero. En una
                sola noche perdí mis ahorros, mis pertenencias y gran parte de
                mi estabilidad emocional.
              </p>
              <p data-id="element-185">
                Fue ahí donde entendí algo que transformó completamente mi vida:
              </p>
            </div>

            <motion.div className="my-10 py-8 border-y border-gold/30 relative" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-186">
              <div className="absolute left-0 top-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-187"></div>
              <p className="font-serif text-2xl md:text-3xl text-ivory-bright text-center leading-snug" data-id="element-188">
                EL PUNTO CERO NO ES EL FINAL.
                <br data-id="element-189" />
                <span className="text-gold italic" data-id="element-190">
                  ES EL LUGAR DONDE COMIENZA LA VERDADERA RECONSTRUCCIÓN.
                </span>
              </p>
              <div className="absolute left-0 bottom-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-191"></div>
            </motion.div>

            <div className="space-y-6 text-muted font-light leading-relaxed" data-id="element-192">
              <p data-id="element-193">
                No fue suerte lo que me ayudó a salir adelante. Fue aprender a
                reconstruirme emocionalmente, fortalecer mi mentalidad,
                recuperar dirección y volver a conectar con Dios y conmigo
                mismo.
              </p>
              <p data-id="element-194">
                Hoy acompaño a personas que sienten ansiedad, vacío emocional,
                bloqueo personal o desconexión en diferentes áreas de su vida.
              </p>
              <p className="text-ivory font-medium" data-id="element-195">
                Personas que por fuera aparentan estar bien… pero por dentro
                sienten que algo se rompió.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}